var o = `#version 300 es

precision highp float;
precision highp isampler2D;

float easing(float t) {
  return t;

  
  
}

uniform float u_debug;

uniform bool u_removeColor;
uniform vec3 u_removeColorOptionsColor;
uniform float u_removeColorOptionsThreshold;
uniform float u_removeColorOptionsHardness;

uniform bool u_colorize;
uniform vec3 u_colorizeOptionsColor;

uniform bool u_grid;

uniform float u_opacity;
uniform float u_saturation;

uniform bool u_distortion;
uniform int u_distortionOptionsdistortionMeasure;

uniform int u_scaleFactorForViewport;

uniform lowp sampler2DArray u_cachedTilesTextureArray;
uniform isampler2D u_cachedTilesResourceOriginPointsAndDimensionsTexture;
uniform isampler2D u_cachedTilesScaleFactorsTexture;

uniform vec4 u_colorDistortion00;
uniform vec4 u_colorDistortion01;
uniform vec4 u_colorDistortion1;
uniform vec4 u_colorDistortion2;
uniform vec4 u_colorDistortion3;
uniform vec4 u_colorGrid;

in vec2 v_resourceTrianglePoint;
in float v_trianglePointDistortion;
in float v_trianglePointIndex;
in vec4 v_trianglePointBarycentric;

out vec4 color;

void main() {
  float resourceTrianglePointX = v_resourceTrianglePoint.x;
  float resourceTrianglePointY = v_resourceTrianglePoint.y;

  
  ivec3 cachedTilesTextureSize = textureSize(u_cachedTilesTextureArray, 0);
  int cachedTilesCount = cachedTilesTextureSize.z;

  
  int smallestScaleFactor;
  bool found = false;
  int foundIndex;

  
  vec3 cachedTilesTexturePoint = vec3(0.0f, 0.0f, 0.0f);

  
  color = vec4(0.0f, 0.0f, 0.0f, 0.0f);

  
  for(int index = 0; index < cachedTilesCount; index += 1) {

    
    float cachedTileResourceOriginPointX = float(texelFetch(u_cachedTilesResourceOriginPointsAndDimensionsTexture, ivec2(0, (index * 4)), 0));
    float cachedTileResourceOriginPointY = float(texelFetch(u_cachedTilesResourceOriginPointsAndDimensionsTexture, ivec2(0, (index * 4) + 1), 0));
    float cachedTileDimensionWidth = float(texelFetch(u_cachedTilesResourceOriginPointsAndDimensionsTexture, ivec2(0, (index * 4) + 2), 0));
    float cachedTileDimensionHeight = float(texelFetch(u_cachedTilesResourceOriginPointsAndDimensionsTexture, ivec2(0, (index * 4) + 3), 0));

    int cachedTileScaleFactor = texelFetch(u_cachedTilesScaleFactorsTexture, ivec2(0, index), 0).r;

    
    if(resourceTrianglePointX >= cachedTileResourceOriginPointX &&
      resourceTrianglePointX < cachedTileResourceOriginPointX + cachedTileDimensionWidth &&
      resourceTrianglePointY >= cachedTileResourceOriginPointY &&
      resourceTrianglePointY < cachedTileResourceOriginPointY + cachedTileDimensionHeight) {

      
      
      
      
      
      if(!(smallestScaleFactor > 0) || cachedTileScaleFactor <= smallestScaleFactor) {
        smallestScaleFactor = cachedTileScaleFactor;
        found = true;
        foundIndex = index;

        float cachedTilePointX = (resourceTrianglePointX - cachedTileResourceOriginPointX) / float(cachedTileScaleFactor);
        float cachedTilePointY = (resourceTrianglePointY - cachedTileResourceOriginPointY) / float(cachedTileScaleFactor);

        float cachedTilesTexturePointX = cachedTilePointX / float(cachedTilesTextureSize.x);
        float cachedTilesTexturePointY = cachedTilePointY / float(cachedTilesTextureSize.y);

        cachedTilesTexturePoint = vec3(cachedTilesTexturePointX, cachedTilesTexturePointY, index);
      }
    }
  }

  if(found == true) {
    
    color = texture(u_cachedTilesTextureArray, cachedTilesTexturePoint);

    if(u_removeColorOptionsThreshold > 0.0f) {
  vec3 backgroundColorDiff = color.rgb - u_removeColorOptionsColor.rgb;
  float backgroundColorDistance = length(backgroundColorDiff);
  if(u_removeColor && backgroundColorDistance < u_removeColorOptionsThreshold) {
    float amount = smoothstep(u_removeColorOptionsThreshold - u_removeColorOptionsThreshold * (1.0f - u_removeColorOptionsHardness), u_removeColorOptionsThreshold, backgroundColorDistance);
    color = vec4(color.rgb * amount, amount);
  }
}

float gray = 0.21f * color.r + 0.71f * color.g + 0.07f * color.b;
color = vec4(color.rgb * (u_saturation) + (gray * (1.0f - u_saturation)), color.a);

if(u_colorize) {
  color = vec4((u_colorizeOptionsColor + color.rgb) * color.a, color.a);
}

color = vec4(color.rgb * u_opacity, color.a * u_opacity);
    if(u_distortion) {
  
  

  float trianglePointDistortion = v_trianglePointDistortion;

  
  trianglePointDistortion = floor(trianglePointDistortion * 10.0f) / 10.0f;

  
  switch(u_distortionOptionsdistortionMeasure) {
    case 0:
      if(trianglePointDistortion > 0.0f) {
        color = mix(color, u_colorDistortion00, trianglePointDistortion);
      } else {
        color = mix(color, u_colorDistortion01, abs(trianglePointDistortion));
      }
      break;
    case 1:
      color = mix(color, u_colorDistortion1, trianglePointDistortion);
      break;
    case 2:
      color = mix(color, u_colorDistortion2, trianglePointDistortion);
      break;
    case 3:
      color = trianglePointDistortion == -1.0f ? u_colorDistortion3 : color;
      break;
    default:
      color = color;
  }
}

if(u_grid) {
  float gridSize = 20.0f * float(u_scaleFactorForViewport);
  float gridWidth = 2.0f * float(u_scaleFactorForViewport);
  if(mod(float(resourceTrianglePointX) + gridWidth / 2.0f, gridSize) < gridWidth || mod(float(resourceTrianglePointY) + gridWidth / 2.0f, gridSize) < gridWidth) {
    color = u_colorGrid;
  }
}
    if(bool(u_debug)) {
  
  

  float dist = 0.99; 
  if(
    v_trianglePointBarycentric.x + v_trianglePointBarycentric.y > dist ||
    v_trianglePointBarycentric.y + v_trianglePointBarycentric.z > dist ||
    v_trianglePointBarycentric.z + v_trianglePointBarycentric.x > dist
  )
  color = vec4(0, 0, 0, 1);
}
  }
}`;
export {
  o as default
};
//# sourceMappingURL=fragment-shader.glsl.js.map
